import type { ShoppingCartContextProps } from 'src/app/shared/hooks/useShoppingCart';
import { getProductFeatureByType } from 'src/app/utils/getProductFeatureByType';
import type { AppState } from 'src/types/appState';

import { getProductFeatureForPreview } from '../getProductFeatureForPreview';

export const getBrandingForPreview = ({
  cartFeatures,
  editFlowCheckout,
  flowType,
  isCartEditFlowFeatureEnabled,
  productFeaturesFromRedux,
}: {
  cartFeatures?: ShoppingCartContextProps['cartFeatures'];
  editFlowCheckout: AppState['session']['editFlowCheckout'];
  flowType: AppState['formData']['flowType'];
  isCartEditFlowFeatureEnabled: boolean;
  productFeaturesFromRedux: AppState['session']['productFeatures'];
}) => {
  let isBrandingEnabled;
  let hasCoverImage;

  if (isCartEditFlowFeatureEnabled) {
    const productBranding = getProductFeatureForPreview({
      featureType: 'Branding',
      productFeaturesFromCart: cartFeatures,
      productFeaturesFromPostedJob: productFeaturesFromRedux,
    });

    isBrandingEnabled = Boolean(productBranding);
    hasCoverImage = Boolean(productBranding?.hasCoverImage);
  } else {
    // Refresh flow does not have a cart. It should use productFeaturesFromRedux
    // When cart is enabled for the edit flow, it should pick up cart features
    const productFeatures =
      flowType === 'create' ? cartFeatures : productFeaturesFromRedux;
    const productBranding = getProductFeatureByType({
      featureType: 'Branding',
      productFeatures,
    });
    // editFlowCheckout.enabled is set only for upgrade path
    isBrandingEnabled = Boolean(productBranding) || editFlowCheckout.enabled;
    hasCoverImage = Boolean(productBranding?.hasCoverImage);
  }

  return {
    isBrandingEnabled,
    hasCoverImage,
  };
};
